import { render, staticRenderFns } from "./FuncionariosFormulario.vue?vue&type=template&id=8595520c"
import script from "./FuncionariosFormulario.vue?vue&type=script&lang=js"
export * from "./FuncionariosFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports